import { BasicRequest } from "./basicRequest";

export class TransformFileRequest extends BasicRequest{

    public transformationDefinitionId! : number;

    constructor(){
        super();
    }
}